import type { Tile } from '../app/context/ContentContext/contentTypes';
import type { TileElement } from './types';

export const getRelatedElement = (tile: Tile, position: number): TileElement => ({
  elementName: 'content tile',
  elementValue: tile.heading?.text ? `${position}-${tile.heading.text}` : `${position}`,
});
